import { render, staticRenderFns } from "./demons.vue?vue&type=template&id=09265d28"
import script from "./demons.vue?vue&type=script&lang=js"
export * from "./demons.vue?vue&type=script&lang=js"
import style0 from "./demons.vue?vue&type=style&index=0&id=09265d28&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports